export default "__VITE_ASSET__0877ab2b__"